/* Generated by scripts/build-search-phrase-rules.mjs — do not edit by hand.
   4974 products, 20 synonym groups.

   Shopify has no phrase search: field:"a b" is answered when both words are
   in that field, in any order. "fields" lists where a phrase can be asked
   without that misreading it; "exclude" names what has to be subtracted
   afterwards. Rebuild after a change to the catalogue or the synonyms. */
window.VinoPhraseRules = {
  "pinot grigio": {"fields":["title","vendor","tag"]},
  "rulandské biele": {"fields":["title","vendor"]},
  "pinot blanc": {"exclude":["pinot noir"]}
};
